import React from "react";
import styles from "./agencia.module.css";
import DOMPurify from "dompurify";

const Agencia = ({ descripcion }) => {
    return (
        <div className={styles.container}>
            <div className={styles.descripcion}>
                <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(descripcion) }} />
            </div>
        </div>
    )
}

export default Agencia;